import React from 'react';
import { EntryType } from '../pages/types';

interface EntryTitleProp {
  entryType: EntryType;
  subTitle?: string;
}
export default function EntryTitle({
  entryType,
  subTitle = '',
}: EntryTitleProp) {
  return (
    <div className="entry-title">
      {entryType === 'recruit' ? '正社員/インターン' : '会社見学'}{subTitle && (
        <>
          <span className="sub-title">{subTitle}</span>
        </>
      )}
    </div>
  );
}